import {useDebugValue} from 'react';

import {noop} from '../../../utils';

import {useEvents} from './';

const defaultSubmitDetailsEvents = {
    onClick: noop
};

function useSubmitDetailsEvents(props) {
    const {
        submitDetailsEvents: propsSubmitDetailsEvents
    } = props;

    const {
        events: submitDetailsEvents
    } = useEvents(defaultSubmitDetailsEvents, propsSubmitDetailsEvents);

    const result = {
        submitDetailsEvents
    };

    useDebugValue(result);

    return result;
}

export {useSubmitDetailsEvents};
